const Tabs = require('@lemonadejs/tabs');

function getPanelTitle(panel, index) {
    return panel.getAttribute('data-ecko-term-timeline-tab-title')
        || panel.getAttribute('data-tab-title')
        || panel.getAttribute('title')
        || `Tab ${index + 1}`;
}

function syncTabButtons(nav, panels, selectedIndex) {
    const buttons = Array.from(nav.querySelectorAll('[data-ecko-term-timeline-tab-target]'));

    buttons.forEach((button, index) => {
        const panel = panels[index];
        const isSelected = index === selectedIndex;

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-selected', isSelected ? 'true' : 'false');

        if (panel && panel.id) {
            button.setAttribute('aria-controls', panel.id);
        }
    });
}

function initTermTimelineTabs(scope = document) {
    const roots = scope.querySelectorAll('[data-ecko-term-timeline-tabs]:not([data-ecko-term-timeline-tabs-initialized])');

    roots.forEach((root) => {
        const group = root.getAttribute('data-ecko-term-timeline-tabs');
        const panels = Array.from(root.children).filter((child) => {
            return child.hasAttribute('data-ecko-term-timeline-tab-key');
        });

        if (!group || panels.length < 2) {
            return;
        }

        root.setAttribute('data-ecko-term-timeline-tabs-initialized', 'true');

        let selectedIndex = panels.findIndex((panel) => panel.hasAttribute('data-selected'));

        if (selectedIndex < 0) {
            selectedIndex = 0;
        }

        panels.forEach((panel, index) => {
            const panelTitle = getPanelTitle(panel, index);

            panel.setAttribute('title', panelTitle);

            if (index === selectedIndex) {
                panel.setAttribute('selected', 'true');
            } else {
                panel.removeAttribute('selected');
            }
        });

        const instance = Tabs(root, {
            selected: selectedIndex,
            onopen: (_tabsInstance, nextIndex) => {
                const nav = document.querySelector(`[data-ecko-term-timeline-tab-nav-for="${group}"]`);

                if (nav) {
                    syncTabButtons(nav, panels, nextIndex);
                }

                panels.forEach((panel, index) => {
                    panel.setAttribute('aria-hidden', index === nextIndex ? 'false' : 'true');
                });
            }
        });

        panels.forEach((panel) => {
            panel.removeAttribute('title');
        });

        const nav = document.querySelector(`[data-ecko-term-timeline-tab-nav-for="${group}"]`);

        if (nav) {
            const buttons = Array.from(nav.querySelectorAll('[data-ecko-term-timeline-tab-target]'));

            buttons.forEach((button) => {
                button.addEventListener('click', () => {
                    const target = button.getAttribute('data-ecko-term-timeline-tab-target');
                    const targetIndex = panels.findIndex((panel) => {
                        return panel.getAttribute('data-ecko-term-timeline-tab-key') === target;
                    });

                    if (targetIndex >= 0) {
                        instance.open(targetIndex);
                    }
                });
            });

            syncTabButtons(nav, panels, selectedIndex);
        }

        panels.forEach((panel, index) => {
            panel.setAttribute('aria-hidden', index === selectedIndex ? 'false' : 'true');
        });
    });
}

module.exports = {
    initTermTimelineTabs
};
